/* eslint-disable jsx-a11y/label-has-associated-control */
import { useEffect, useState } from 'react';
import Urls from '../../utils/urls';

import { prefixPath } from '../../utils/helpers';
import BaseUrls from '../../utils/baseUrls';
import apiBackendInstance from '../../utils/axios';

const MyDetails = () => {
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [email, setEmail] = useState('');
  useEffect(() => {
    apiBackendInstance.get(Urls.getUserInfo(), {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    })
      .then((response) => {
        const { data } = response;
        setEmail(data.data.usercred);
        setFirstName(data.data.first_name);
        setLastName(data.data.last_name);
      })
      .catch(() => { setFirstName('Not '); setLastName('Found '); setEmail('Not Found'); });
  }, []);
  const theme = BaseUrls.getkey();
  const baseUrl = window.location.origin;
  const userImg = baseUrl + prefixPath(`/img/${theme}/username-icon.png`);
  const emailImg = baseUrl + prefixPath(`/img/${theme}/email.png`);
  const phoneImg = baseUrl + prefixPath(`/img/${theme}/call.png`);
  const countryImg = baseUrl + prefixPath(`/img/${theme}/country.png`);

  return (
        <div
            className="tab-pane fade show active"
            id="home"
        >
            <h5 className="mx-3 mt-4">User Details</h5>
            <div className="row mx-2 mt-4">
                <div className="row gap-3 col-xl-8 col-lg-10 col-md-12 col-sm-12 ">
                    <div className="col-xl-5 col-lg-5 col-md-12 col-sm-12 ">
                        <div className="input-group mb-3 inputGroup">
                            <span className="input-group-text transparent" id="">
                                <img src={userImg} alt="" />
                            </span>
                                <input type="text" disabled className="form-control" defaultValue={firstName} />
                        </div>
                    </div>
                    <div className="col-xl-5 col-lg-5 col-md-12 col-sm-12">
                        <div className="input-group mb-3 inputGroup">
                            <span className="input-group-text transparent" id="">
                                <img src={userImg} alt="" />
                            </span>
                                <input type="text" disabled className="form-control" defaultValue={lastName} />
                        </div>
                    </div>
                </div>
                <div className="mt-4 row gap-3 col-xl-8 col-lg-10 col-md-12 col-sm-12 ">
                    <div className="col-xl-5 col-lg-5 col-md-12 col-sm-12">
                        <div className="input-group mb-3 inputGroup">
                            <span className="input-group-text transparent" id="">
                                <img src={emailImg} alt="" />
                            </span>
                                <input type="text" disabled className="form-control" defaultValue={email} />
                        </div>
                    </div>
                    <div className="col-xl-5 col-lg-5 col-md-12 col-sm-12">
                        <div className="input-group mb-3 inputGroup">
                            <span className="input-group-text transparent" id="">
                                <img src={phoneImg} alt="" />
                            </span>
                                <input type="text" disabled className="form-control" defaultValue="Not Set" />
                        </div>
                    </div>
                </div>
                <div className="mt-4 row gap-3 col-xl-8 col-lg-10 col-md-12 col-sm-12 ">
                    <div className="col-xl-5 col-lg-5 col-md-12 col-sm-12">
                        <div className="input-group mb-3 inputGroup ">
                            <span className="input-group-text transparent" id="">
                                <img src={countryImg} alt="" />
                            </span>
                                <input type="text" disabled className="form-control" defaultValue="Not Set" />
                        </div>
                    </div>
                </div>
            </div>
            <hr className="col-11" />
            <div className="col-11 text-end">
             <button type="button" style={{ display: 'none' }} disabled className="btn comingSoon mt-1 text-end">Update Profile</button>
            </div>
        </div>

  );
};
export default MyDetails;
